import { AllNbisivPermission } from "presentation/constant/ANAInfo/NbisivPermission";
import { useRevenueReconciliationReportVM } from "presentation/hook/RevenueReconciliationReport/useRevenueReconciliationReportVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { memo, useEffect, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import RevenueReconciliationReportPanel from "./RevenueReconciliationReportPanel";

const RevenueReconciliationReportMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const revenueReconciliationReportVM = useRevenueReconciliationReportVM();


    const [anaInfoState] = useANAInfoTracked();
    const { allNbisivPermission } = anaInfoState;
    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    revenueReconciliationReportVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            revenueReconciliationReportVM.initRevenueReconciliationReportList(allNbisivPermission as AllNbisivPermission).then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [revenueReconciliationReportVM, allNbisivPermission])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>

            {<>
                <RevenueReconciliationReportPanel /></>}

        </div>
    </>
}

export default memo(RevenueReconciliationReportMaintenance);